// @flow
import {Typography, makeStyles} from '@material-ui/core';
import React, {useRef, useState} from 'react';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';

import logoImg from '../../../../assets/img/onboarding/logo-step.png';
import {useIsMobile} from '../../../../utils/dom';
import CropModal from '../../../../elements/CropModal';

import {useBindedActions} from '../../../../utils/globalStore';

import {actions as CustomizeActions} from '../../../my-store/customize/duck';

import type {ImageToCrop} from '../../../../elements/CropModal';
import type {SaveInformationRequest} from '../../../my-store/customize/api';
import {useTypedSelector} from '../../../../store';
import LoadingSpinner from '../../../../elements/LoadingSpinner/LoadingSpinner';
import SnackBar from '../../../../elements/SnackBar/SnackBar';
type Props = {};

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1.5),
    backgroundColor: 'white',
    borderRadius: 8,
  },
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      gap: '12px',
    },
  },
  title: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: 12,
  },
  subtitle: {
    fontSize: 12,
  },
  button: {
    marginTop: theme.spacing(2),
    borderRadius: 8,
  },
  imgWrap: {
    maxWidth: 150,
  },
  img: {
    maxWidth: '100%',
  },
}));

const CoverStep = (props: Props) => {
  const classes = useStyles();
  const mobile = useIsMobile();

  const isSaving = useTypedSelector(state => state.myStore.isSaving);
  const error = useTypedSelector(state => state.myStore.error);

  const fileRef = useRef<HTMLInputElement | null>(null);
  const [file, setFile] = useState<File | null>(null);

  const {saveStoreInformation} = useBindedActions(CustomizeActions);
  const onSelectLogo = () => {
    if (fileRef.current) fileRef.current.click();
  };

  const handleUploadFile = (file: File) => setFile(file);

  const onCropResult = (result: ImageToCrop) => {
    setFile(null);
    const storeInformationRequest: SaveInformationRequest = {
      logoShapeType: 'SQUARE',
      logoImageFile: result.file,
    };
    saveStoreInformation({storeInformationRequest});
  };

  return (
    <div className={classes.root}>
      {isSaving && <LoadingSpinner />}
      <SnackBar
        mode="error"
        message={error ? 'No se pudo actualizar información de la tienda.' : ''}
      />
      <div className={classes.content}>
        <div>
          <Typography className={classes.title} gutterBottom>
            Logo de tu marca
          </Typography>

          <Typography className={classes.subtitle} gutterBottom>
            Personaliza tu tienda y muestra tu marca
          </Typography>

          {file && (
            <CropModal
              open
              onClose={() => setFile(null)}
              aspect={1}
              compressOptions={{
                quality: 0.8,
                maxWidth: 3840,
                maxHeight: 3840,
              }}
              images={[{preview: URL.createObjectURL(file), file}]}
              onSubmit={([result]) => onCropResult(result)}
            />
          )}

          <input
            ref={fileRef}
            type="file"
            hidden
            accept="image/*"
            onChange={event => {
              const file = event.target.files[0];
              if (file) {
                handleUploadFile(file);
              }
            }}
          />
          <CustomButton
            fullWidth={mobile}
            variant="contained"
            className={classes.button}
            // to="/configure/customize?fromOnboarding=true"
            onClick={onSelectLogo}
          >
            Agregar Logo
          </CustomButton>
        </div>

        <div className={classes.imgWrap}>
          <img src={logoImg} className={classes.img} alt="" />
        </div>
      </div>
    </div>
  );
};

export default CoverStep;
